import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUserAdded: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUserAdded"><Path d="M11 20.5H4.5V19.5C4.5 15.3579 7.85786 12 12 12" stroke="currentColor"/><Circle cx="12" cy="7.5" r="4.5" stroke="currentColor"/><Path d="M13.5 18.5L16 20.5L20.5 13.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUserAdded;
